import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MenuBookIcon(props: IconProps) {
    return <Icon {...props} iconKey={"menu_book"}/>
}
